import { action, observable } from 'mobx'
import { IShelfConfig } from '@/model/types/mall'

export class GoodsShelfStore {
    @observable mallShelfConfig: IShelfConfig | null = null

    @observable
    public groupId: number | undefined = undefined // 一级分组ID

    @observable
    public secondGroupId?: number // // 二级分组ID

    @observable
    public keyWord: string = '' // 商品搜索关键字

    @observable
    public status: boolean = true // 显示未上架商品

    @observable
    public updateGroupStatus?: boolean = false // 用于刷新当前选中分组

    @observable
    public resetSatus: boolean = false // 重置分组选中并刷新

    @observable
    public groupIds: number[] = [] // 根据分组筛选

    @observable
    public updateGroup: boolean = false // 刷新分组

    @action
    public setUpdateGroup() {
        this.updateGroup = !this.updateGroup
    }

    @action
    public setGroupIds(groupsIds: number[]) {
        this.groupIds = groupsIds
    }

    @action
    setShelfConfig(config: IShelfConfig) {
        this.mallShelfConfig = config
    }

    @action
    public resetGoodTableData() {
        this.secondGroupId = 0
        this.groupId = 0
        this.resetSatus = !this.resetSatus
    }

    @action
    public setActiveGroupId(id: number | undefined) {
        this.groupId = id
    }

    @action
    public setActiveSecondGroupId(id?: number) {
        this.secondGroupId = id
    }

    @action
    public setUpdateGroupStatus(status?: boolean) {
        if (status) {
            this.updateGroupStatus = status
        } else {
            this.updateGroupStatus = !this.updateGroupStatus
        }
    }

    @action
    setKeyWord(keyWord: string) {
        this.keyWord = keyWord
    }

    @action
    changeStatus(status: boolean) {
        this.status = status
    }
}

export const goodsShelfStore = new GoodsShelfStore()
